import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~shared/api";
import { isDefaultOperationSucceeded } from "~utils/defaultOperationResponse.ts";

export const useResetFixture = () => {
  const { sport, organizationId, seasonId } = useParams();
  const { mutateData } = useApi();

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (fixtureId: string) => {
      return await mutateData({
        url: `${sport}/o/${organizationId}/fixtures/${fixtureId}/reset?forceDelete=true`,
        method: "POST",
      });
    },
    onSuccess: (response: any) => {
      if (isDefaultOperationSucceeded(response)) {
        queryClient.invalidateQueries({
          queryKey: ["fixtureListPage", sport, organizationId, seasonId],
        });
      }
    },
  });
};
